// React Imports
import React from 'react';
import PropTypes from 'prop-types';

// Spectrum components
import { StepList, Step } from '@react/react-spectrum/StepList';

// I18n
import { Translate } from 'react-redux-i18n';

/**
 * Component for displaying the application progress.
 *
 * This component displays the application progress
 *
 * @component
 * @example
 *
 * return (
 *   <Progress step={0} />
 * )
 */
const Progress = ({ step }) => (
  <StepList interaction="off" selectedIndex={step}>
    <Step><Translate value="workflow.progress.sign_in" /></Step>
    <Step><Translate value="workflow.progress.select_company" /></Step>
    <Step><Translate value="workflow.progress.personal_information" /></Step>
    <Step><Translate value="workflow.progress.finish" /></Step>
  </StepList>
);
Progress.propTypes = {
  /* Step {number} The step index to highlight. */
  step: PropTypes.number.isRequired,
};

export default Progress;
